import { FormElems } from 'components';
import { MLE_CREATE_FORM_NAME } from 'components/Onboarding/Mle/BusinessTab/contants';
import MultiImageViewModal from 'components/Onboarding/Mle/BusinessTab/MultiImageViewModal';
import MyTooltip from 'components/Onboarding/Mle/BusinessTab/MyTooltip';
import { FILE_MSG, FILE_MSG_WITH_EXT } from 'components/Onboarding/Mle/mle.constants';
import { fetchFieldValue, getFileListUrls, getFormattedDateusingUrl, isApproved,mapCheckerRemarksKeyWithNames, redClassRemarksCond } from 'components/Onboarding/Mle/mle.utils';
import React, { useEffect, useState, useRef } from 'react'
import { Field } from 'redux-form';
import { ACCEPT_IMG_PDF, MAX_25MB, MAX_5MB, MAX_FILE_SIZE } from 'utils/constants/commonValues';
import test1Image from '../../static/images/test1.png';
import test2Image from '../../static/images/test2.png';
import { toast } from 'react-toastify';
import { last } from 'lodash';
import TitleComponent from 'components/TitleComponent';

let allowedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'pdf'];

const SingleUpload = (props) => {
    const {
        handleFileChange,
        handleUploadImageAndGetUrl,
        handleViewClick,
        fieldName,
        fileUrl,
        placeholder,
        disabled,
        infoElement,
        labelName
    } = props;
    return (
        <Field
                handleChange={(name, value) => {
                    handleFileChange(name, value);
                }}
                uploadImageAndGetURL={handleUploadImageAndGetUrl}
                handleView={handleViewClick}
                name={fieldName}
                docUrl={fileUrl}
                type="file"
                id={fieldName}
                component={FormElems.UploadElement}
                placeholder={placeholder}
                allowedExtensions={allowedExtensions}
                MaxFileSize={MAX_FILE_SIZE}
                accept={ACCEPT_IMG_PDF}
                disabled={disabled}
                infoElement={infoElement}
                labelName={labelName}
          />
    )
}

// [
//     test1Image,
//     test2Image
// ]

const MultiUpload = (props) => {
    const {
        setFileListUrl,
        fileListUrl,
        name,
        handleUploadImageAndGetUrl,
        handleViewClick,
        isViewMode,
        maxFiles,
        defaultDate,
        checkoutMigrated
    } = props;
    const [fileList, setFileList] = useState([]);
    const [multiViewDocument, setMultiViewDocument] = useState(null);
    const [documentDetails, setDocumentDetails] = useState([]);

    useEffect(() => {
        if (fileListUrl && fileListUrl.length) {
            const documentDetails = fileListUrl.map((url, index) => {
                let splitUrl = url.split('/');
                if (splitUrl.length > 2) {
                    const fileName = splitUrl[splitUrl.length - 1];
                    const timeStamp = splitUrl[splitUrl.length - 2];
                    return {
                        url,
                        fileName,
                        timeStamp,
                        index
                    };
                }
                return {};
            });
            setDocumentDetails(documentDetails);
        } else {
            setDocumentDetails([]);
        }
    }, [fileListUrl]);

    const fetchS3Url = async () => {
        if (fileList?.length) {
            try {
                const urls = await Promise.all(
                    fileList.map(file => handleUploadImageAndGetUrl(file))
                );
                setFileListUrl((prev) => [...prev, ...urls]);
            } catch (error) {
                console.error('Error fetching URLs:', error);
                // Optionally, handle the error further (e.g., show a user-friendly message)
            }
        }
    }

    const fetchViewUrl = async () => {
        
        if (fileListUrl?.length) {
            try {
                const urls = await getFileListUrls(fileListUrl, checkoutMigrated);
                setMultiViewDocument(urls.filter(url => !!url));
            } catch (error) {
                console.error('Error fetching URLs:', error);
                // Optionally, handle the error further (e.g., show a user-friendly message)
            }
        }
    }

    const handleDeleteFile = (index) => {
        if (isViewMode) {
            return null;
        }
        try {
            setFileListUrl((prev) => {
                if (prev && Array.isArray(prev)) {
                    const newArr =  [...prev.slice(0, index), ...prev.slice(index + 1)];
                    return newArr;
                }
                return prev;
            });
            setMultiViewDocument(null);
            toast.info("File deleted successfully.");
        } catch(e) {
            toast.error("File delete unsuccess.");
            console.log("e", e);
        }
    }
    useEffect(() => {
        fetchS3Url()
    }, [fileList]);
    const handleViewClickBtn = () => {
        if (fileListUrl.length) {
            fetchViewUrl()
        }
    }
    return (
        <>
            {
                multiViewDocument?.length &&
                <MultiImageViewModal
                    multiDocuments={multiViewDocument}
                    setMultiDocuments={setMultiViewDocument}
                    handleDeleteFile={handleDeleteFile}
                    documentDetails={documentDetails}
                    defaultDate={defaultDate}
                />
            }
            <div className="form-section">
                <Field
                    name={name}
                    type="file"
                    onFileListChange={files => setFileList(files)}
                    fileList={fileList}
                    accept=".pdf, .jpg, .jpeg, .png, .svg"
                    // subtitle="Maximum file size 25MB. Only PDF, doc, excel, .zip and image files are accepted"
                    component={FormElems.MultiUploadUrlHandling}
                    maxSize={MAX_5MB}
                    fileListUrl={fileListUrl}
                    handleViewImages={handleViewClickBtn}
                    maxFiles={maxFiles}
                    id={name}
                    isViewMode={isViewMode}
                />
            </div>
        </>
    );
}

// [
//     "/kycDocFile/merchant/MERd812874e6a/Mon Dec 30 13:32:29 IST 2024/Screenshot 2024-12-04 175926.png",
//     "/kycDocFile/merchant/MERd812874e6a/Mon Dec 30 13:32:29 IST 2024/Screenshot 2024-12-04 175926.png"
// ]

const FileUploadField = ({
    itemInfo,
    isViewMode,
    docUrls,
    setDocUrls,
    errors,
    resetFieldError,
    handleUploadImageAndGetUrl,
    handleViewClick,
    prefix,
    actions,
    handleDeleteFile,
    values = null,
    prefixReqName= null,
    checkerRemarks,
    required,
    clearedClicked,
    multi,
    formName = null,
    isEditMode = false,
    isEditable = false,
    isReEditFlow = false,
    infoMsgs = {},
    initialValue,
    isReset = false,
    showDate = false,
    defaultDate = null,
    checkoutMigrated
}) => {

    let itemReqName = (prefixReqName)
    ? `${prefixReqName}.${itemInfo.docType || itemInfo.reqname}`
    : `${itemInfo.docType || itemInfo.reqname}`;

    const [fileUrl, setFileUrl] = useState(fetchFieldValue(values, itemReqName) || '');
    const [fileListUrl, setFileListUrl] = useState(fetchFieldValue(values, itemReqName) || []);
    const handleFileChange = (name, value) => {
        setFileUrl(value);
        if(!value){
            setFileListUrl([]);
            actions.change(formName, itemReqName, null);
        }
    }
    // update docurl for multi upload
    useEffect(() =>{
        if(setDocUrls && multi){
            setDocUrls(preData => ({...preData, [itemInfo.docType] : fileListUrl }));
        }
    }, [fileListUrl, multi])
    // on change of file url update the state
    useEffect(() =>{
        if(setDocUrls && !multi){
            setDocUrls(preData => ({...preData, [itemInfo.docType] : [fileUrl] }));
        }
    }, [fileUrl, multi])
    // on change of initial value update the state
    useEffect(() => {
        
        if(initialValue && multi){
            setFileListUrl(initialValue);
        }else if(initialValue && initialValue.length > 0){
            if (typeof initialValue === 'string')
                setFileUrl(initialValue);
            else
                setFileUrl(initialValue[0]);
        }else if(!initialValue) {
            setFileUrl('');
            setFileListUrl([]);
        }
    }, [initialValue]);

    // file listing url update form state variable
    useEffect(() => {
        if (fileListUrl?.length && formName) {
            actions.change(formName, itemReqName, fileListUrl);
        } else if (fileListUrl?.length === 0 && formName) {
            actions.change(formName, itemReqName, null);
        }
    }, [fileListUrl]);

    let fieldName = itemInfo.name || itemInfo.docType;
    if (prefix) {
        fieldName = `${prefix}.${fieldName}`;
    }
    // deleting file 
    useEffect(() => {
        if (!fileUrl) {
            handleDeleteFile()
        }

    }, [fileUrl])
    // on clear click update the state
    useEffect(() => {

        if (clearedClicked) {
            if (isReset) {
                setFileUrl(fetchFieldValue(values, itemReqName) ?? '');
                setFileListUrl(fetchFieldValue(values, itemReqName) || []);
            } else {
                setFileUrl('')
                setFileListUrl([])
            }
        }
    }, [clearedClicked]);
let remarkKeyName = itemReqName;

    
  return (
      <div className="field-array-section no-border form-field uploadDivContainer">
        <TitleComponent
            field={{label: itemInfo.label || itemInfo.docName, fieldValidations: {required}}}
            checkerRemarks={checkerRemarks}
            isEditMode={isEditMode}
            isReEditFlow={isReEditFlow}
            infoMsgs={infoMsgs}
            fieldName={mapCheckerRemarksKeyWithNames(remarkKeyName)}
            fieldDate={showDate?getFormattedDateusingUrl(!!fileUrl? fileUrl: fileListUrl, defaultDate):''}
        />
        {
            !!multi &&
            <MultiUpload
            checkoutMigrated={checkoutMigrated}
                setFileListUrl={setFileListUrl}
                fileListUrl={fileListUrl}
                name={fieldName}
                handleUploadImageAndGetUrl={handleUploadImageAndGetUrl}
                handleViewClick={handleViewClick}
                isViewMode={(isViewMode ||
                    (!isReEditFlow && isApproved(checkerRemarks, remarkKeyName)) ||
                    (isEditMode && !isEditable) ||
                    (isReEditFlow && !isEditable))
                }
                maxFiles={itemInfo?.maxDocCount || 1}
                defaultDate={defaultDate}
            />

        }
        {
            !multi &&
            <SingleUpload
                handleFileChange={handleFileChange}
                handleUploadImageAndGetUrl={handleUploadImageAndGetUrl}
                handleViewClick={handleViewClick}
                fieldName={fieldName}
                fileUrl={fileUrl}
                placeholder={itemInfo.label || itemInfo.docName}
                allowedExtensions={allowedExtensions}
                MaxFileSize={MAX_FILE_SIZE}
                accept={ACCEPT_IMG_PDF}
                infoElement={`${FILE_MSG_WITH_EXT}${allowedExtensions.join(', ')}`}
                disabled={
                    isViewMode ||
                    isApproved(checkerRemarks, remarkKeyName) ||
                    (isEditMode && !isEditable)
                }
                labelName={(itemInfo?.docName)?`${itemInfo.docName} file`: undefined}
            />

        }

          {errors && <div className="error-message-multiplefields">{errors}</div>}
      </div>
  );
}

export default FileUploadField
